// @ts-nocheck
import { createBrowserHistory, History } from '/builds/litta-front/litta-palmer/node_modules/@umijs/runtime';

let options = {
  "basename": "/litta-palmer/"
};
if ((<any>window).routerBase) {
  options.basename = (<any>window).routerBase;
}

// remove initial history because of ssr
let history: History = process.env.__IS_SERVER ? null : createBrowserHistory(options);
export const createHistory = (hotReload = false) => {
  if (!hotReload) {
    history = createBrowserHistory(options);
  }

  return history;
};

export { history };
